import { useTranslation } from 'react-i18next'
import { isNil } from 'lodash'

import { Post } from 'lib/_types'

import './style.scss'

const PostEdited = ({ post }: { post: Post }) => {
  const { t } = useTranslation()

  if (isNil(post?.edited_at)) {
    return null
  }

  return <div className="PostEdited">{t('post.edited')}</div>
}

export default PostEdited
